/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function ErrorIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none" {...props }>
      <path d="M13.3333 0C5.97333 0 0 5.97333 0 13.3333C0 20.6933 5.97333 26.6667 13.3333 26.6667C20.6933 26.6667 26.6667 20.6933 26.6667 13.3333C26.6667 5.97333 20.6933 0 13.3333 0ZM14.6667 20H12V17.3333H14.6667V20ZM14.6667 14.6667H12V6.66667H14.6667V14.6667Z" />
    </SvgIcon>
  );
}
